import { render } from "./AddNewProduitModal.vue?vue&type=template&id=62f80f59&ts=true"
import script from "./AddNewProduitModal.vue?vue&type=script&lang=ts"
export * from "./AddNewProduitModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__